import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import r from "../managers/braze-instance.js";
import { getAlias as ce } from "../managers/utils.js";
import { isObject as It } from "../util/code-utils.js";
import { convertMsToSeconds as X, timestampOrNow as ts } from "../util/date-utils.js";
var ue = /*#__PURE__*/function () {
  function ue(t, s, i, r, e) {
    _classCallCheck(this, ue);
    this.userId = t, this.type = s, this.time = i, this.sessionId = r, this.data = e, this.userId = t, this.type = s, this.time = ts(i), this.sessionId = r, this.data = e;
  }
  _createClass(ue, [{
    key: "Ar",
    value: function Ar() {
      var t;
      var s = {
        name: this.type,
        time: X(this.time),
        data: this.data || {},
        session_id: this.sessionId
      };
      null != this.userId && (s.user_id = this.userId);
      var i = (null === (t = r.Sr()) || void 0 === t ? void 0 : t.fh()) || !1;
      if (!s.user_id && !i) {
        var _t = ce(r.p());
        _t && (s.alias = _t);
      }
      return s;
    }
  }, {
    key: "dt",
    value: function dt() {
      return {
        u: this.userId,
        t: this.type,
        ts: this.time,
        s: this.sessionId,
        d: this.data
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ue(t.user_id, t.name, t.time, t.session_id, t.data);
    }
  }, {
    key: "gE",
    value: function gE(t) {
      return null != t && It(t) && null != t.t && "" !== t.t;
    }
  }, {
    key: "qn",
    value: function qn(t) {
      return new ue(t.u, t.t, t.ts, t.s, t.d);
    }
  }]);
  return ue;
}();
export { ue as default };